const SearchReducers = (state = { Results: [], suggestedKey: null, isLoaded: false }, action) => {
    switch (action.type) {
        case "SEARCH_LOADING":
            return {
                Results: [],
                suggestedKey: null,
                isLoaded: false
            };
        case "SEARCH_INITIAL":
            return {
                Results: action.data.Results || [],
                suggestedKey: action.data.suggestedKey || null,
                isLoaded: true
            };
        default:
            return state;
    }
}

export default SearchReducers;